import React, { useEffect, useState } from "react";
import { AdminService } from "../../services/adminService";
import "./AdminLoginModal.css";

interface AdminLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoggedIn: () => void;
}

const AdminLoginModal: React.FC<AdminLoginModalProps> = ({
  isOpen,
  onClose,
  onLoggedIn,
}) => {
  const [code, setCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCode("");
      setErrorMessage("");
      setIsSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const trimmed = code.trim();
      const ok = await AdminService.login(trimmed);
      if (ok) {
        onLoggedIn();
        onClose();
      } else {
        setErrorMessage("認証に失敗しました。パスコードを確認してください。");
      }
    } catch (error) {
      console.error("管理者ログインエラー", error);
      setErrorMessage("通信エラーが発生しました。ネットワークをご確認ください。");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="admin-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-login-title"
      onClick={handleOverlayClick}
    >
      <div
        className="admin-modal-card"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="admin-modal-close"
          onClick={onClose}
          aria-label="ログインモーダルを閉じる"
          disabled={isSubmitting}
        >
          ×
        </button>
        <div className="admin-modal-header">
          <p className="admin-modal-subtitle">WATCH TOGETHER ADMIN</p>
          <h3 id="admin-login-title" className="admin-modal-title">
            管理者ログイン
          </h3>
          <p className="admin-modal-helper">
            運営用のパスコードを入力してください。認証に成功すると管理ツールが表示されます。
          </p>
        </div>
        <form className="admin-modal-form" onSubmit={handleSubmit}>
          <label className="admin-modal-label" htmlFor="admin-passcode">
            パスコード
            <input
              id="admin-passcode"
              className="admin-modal-input"
              type="password"
              autoComplete="current-password"
              placeholder="例: moonlight-astral"
              value={code}
              onChange={(event) => setCode(event.target.value)}
              autoFocus
              disabled={isSubmitting}
            />
          </label>
          {errorMessage && (
            <div className="admin-modal-error" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="admin-modal-actions">
            <button
              type="button"
              className="admin-modal-button is-secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="admin-modal-button is-primary"
              disabled={isSubmitting || code.trim().length === 0}
            >
              {isSubmitting ? "認証中…" : "ログイン"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginModal;


